import {
  ADD_PURCHASE_LINE_DETAILS,
  UPDATE_PURCHASE_LINE_DETAILS,
  GET_PURCHASE_LINE_DETAILS,
  GET_PURCHASE_LINE_DETAIL,
  DELETE_PURCHASE_LINE_DETAILS,
} from '../types';

const initialState = {
  list: [],
  single: null,
  loading: true,
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case ADD_PURCHASE_LINE_DETAILS:
      return { ...state, list: [...state.list, payload] };
    case UPDATE_PURCHASE_LINE_DETAILS:
      return {
        ...state,
        list: state.list.map((item) =>
          item.id === payload.id ? payload : item,
        ),
      };
    case GET_PURCHASE_LINE_DETAILS:
      return { ...state, list: payload };
    case GET_PURCHASE_LINE_DETAIL:
      return { ...state, single: payload };
    case DELETE_PURCHASE_LINE_DETAILS:
      return {
        ...state,
        list: state.list.filter((item) => item.id !== payload.id),
      };
    default:
      return state;
  }
};

export default reducer;
